import "./style.css";

export const Loader = () => {
	return (
		<div style={{ textAlign: "center" }}>
			<div className="lds-circle">
				<div></div>
			</div>
			<p>Processing your transaction...</p>
		</div>
	);
};
